import { Type11File, Type11FileType } from "./Type11File";
import { Component, Input, OnInit, Optional } from "@angular/core";
import { PagingTableComponent, TabComponent, ModalTabComponent } from "@xo/client-common";

@Component({
    selector: "spec-app-type11-file-table",
    styleUrls: ["./type11File.table.scss"],
    templateUrl: "./type11File.table.html"
})
export class Type11FileTable extends PagingTableComponent<Type11File> implements OnInit {

    @Input() title: string;

    Type11File = Type11File;


    constructor(
        @Optional() modalTab: ModalTabComponent, @Optional() tab: TabComponent) {
        super(Type11FileType, Type11File.columnInfo, modalTab || tab);
    }

    async ngOnInit() {
        this.refreshList();
    }

    getClasses(type11File) {
        let classes: any = { objects: true };
        return classes;
    }
}
